import { IconX } from "@tabler/icons-react";
import { filtrosNoVacios, type SolicitudFiltros, type SolicitudSortKey } from "../utils/ordenar-solicitudes";

const ETIQUETAS: Partial<Record<SolicitudSortKey, string>> = {
  folio: "Folio",
  estado: "Estado",
  tipo: "Tipo",
  organizacion: "Organización",
  area: "Área",
  proveedor: "Proveedor",
  rfcProveedor: "RFC",
  descripcion: "Descripción",
  total: "Total",
  moneda: "Moneda",
  fechaPago: "Fecha pago",
  numDoc: "Núm. Doc",
  creacion: "Creación",
  ultimaActividad: "Última actividad",
};

const LLAVES_FECHA = new Set<string>(["fechaPago", "creacion", "ultimaActividad"]);

/** "2026-08-08" (formato del filtro/server) → "08/08/2026" para el chip. */
function valorLegible(key: string, valor: string): string {
  if (LLAVES_FECHA.has(key) && /^\d{4}-\d{2}-\d{2}$/.test(valor)) {
    const [y, m, d] = valor.split("-");
    return `${d}/${m}/${y}`;
  }
  return valor;
}

/**
 * Chips de los filtros por columna ACTIVOS (revisión UX) · hacen visible qué
 * está filtrado aunque la fila de filtros esté colapsada, con "×" para quitar
 * cada uno y "Limpiar filtros" cuando hay varios. Vive junto al botón
 * "Filtros" en la toolbar del listado.
 */
export function FiltrosActivos({
  filtros,
  onQuitar,
  onLimpiar,
}: {
  filtros: SolicitudFiltros;
  onQuitar: (key: SolicitudSortKey) => void;
  onLimpiar: () => void;
}) {
  const activos = Object.entries(filtrosNoVacios(filtros)) as [SolicitudSortKey, string][];
  if (activos.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {activos.map(([key, valor]) => (
        <button
          key={key}
          type="button"
          onClick={() => onQuitar(key)}
          aria-label={`Quitar filtro ${ETIQUETAS[key] ?? key}: ${valor}`}
          className="group inline-flex max-w-60 items-center gap-1 rounded-full border border-input bg-muted/40 py-0.5 pl-2.5 pr-1.5 text-xs text-foreground transition-colors hover:border-peligro-300 hover:bg-peligro-50 dark:hover:bg-peligro-900/20"
        >
          <span className="text-muted-foreground">{ETIQUETAS[key] ?? key}:</span>
          <span className="truncate font-medium">{valorLegible(key, valor)}</span>
          <IconX size={12} stroke={2} className="shrink-0 text-muted-foreground group-hover:text-peligro-600" />
        </button>
      ))}
      {activos.length > 1 && (
        <button
          type="button"
          onClick={onLimpiar}
          className="text-xs text-multiva-600 hover:underline"
        >
          Limpiar filtros
        </button>
      )}
    </div>
  );
}
